module.exports = __webpack_public_path__ + "img/16-1.ba691145.png";